import type { ReactNode } from 'react';

export const symbol_lock_open_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M370-330h220q18.75 0 31.88-13.13Q635-356.25 635-375v-140q0-18.75-13.12-31.88Q608.75-560 590-560h-15v-65q0-39-28-67t-67-28q-39 0-67 28t-28 67v5h50v-5q0-19.13 12.91-32.06 12.91-12.94 32-12.94T512-657.06q13 12.93 13 32.06v65H370q-18.75 0-31.87 13.12Q325-533.75 325-515v140q0 18.75 13.13 31.87Q351.25-330 370-330ZM480.27-80q-82.74 0-155.5-31.5Q252-143 197.5-197.5t-86-127.34Q80-397.68 80-480.5t31.5-155.66Q143-709 197.5-763t127.34-85.5Q397.68-880 480.5-880t155.66 31.5Q709-817 763-763t85.5 127Q880-563 880-480.27q0 82.74-31.5 155.5Q817-252 763-197.68q-54 54.31-127 86Q563-80 480.27-80Zm.23-60Q622-140 721-239.5t99-241Q820-622 721.19-721T480-820q-141 0-240.5 98.81T140-480q0 141 99.5 240.5t241 99.5Zm-.5-340Z"
		/>
	</svg>
);
